import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fi-icon-custom-connected-icon",
  "use": "fi-icon-custom-connected-icon-usage",
  "viewBox": "0 0 24.501 24.501",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24.501 24.501\" id=\"fi-icon-custom-connected-icon\">\n  <path id=\"fi-icon-custom-connected-icon_Combined_Shape-2\" data-name=\"Combined Shape\" d=\"M20.582,24.5A20.606,20.606,0,0,0,0,3.92V0A24.5,24.5,0,0,1,24.5,24.5Zm-9.1,0A11.5,11.5,0,0,0,0,13.016V9.187A15.316,15.316,0,0,1,15.314,24.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol